import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { track } from '../../utils/track';
import { lifecycle } from './actions';
import { fullRegistartionInfo } from './selectors';
import PersonalDataForm from './components/PersonalDataForm';
import VerificationForm from './components/VerificationForm';
import LoginAndPasswordForm from './components/LoginAndPasswordForm';

import './index.scss';

export interface Props {
  source: string;
  landing: string;
}

type Enhanced = Props & ReturnType<typeof fullRegistartionInfo>;

const enhance = compose<Enhanced, Props>(
  track({ activate: lifecycle.activate }),
  connect(fullRegistartionInfo)
);

export class FullRegistration extends React.Component<Enhanced> {
  render() {
    return <div className="full-registration">{this.renderStep()}</div>;
  }

  private renderStep() {
    const { step, source, landing } = this.props;
    switch (step) {
      case 'PERSONAL_DATA':
        return <PersonalDataForm source={source} landing={landing} />;
      case 'VERIFIACTION':
        return <VerificationForm />;
      case 'LOGIN_AND_PASSWORD':
        return <LoginAndPasswordForm />;
    }
  }
}

export default enhance(FullRegistration);
